const TRANSPORTER_CONTACT_NUMBER_FIELD = 'Transporter Contact Number';

export const getDeliveryCsvReportData = (reportData, includeTransporterContactNumber) => {
  if (includeTransporterContactNumber || !Array.isArray(reportData)) {
    return reportData;
  }

  return reportData.map((item) => {
    if (!item || typeof item !== 'object') {
      return item;
    }

    const data = { ...item };
    delete data[TRANSPORTER_CONTACT_NUMBER_FIELD];
    return data;
  });
};
